import React from 'react';
import { Box, Typography } from '@mui/material';

export const CertificateHeader = ({ isLeavingCertificate = false, details = {}, school = {} }) => {
    // Standard school details as provided in the image/requirements
    const schoolAddress = "Supe, Tal- Baramati, Dist. - Pune - 412204";
    const approvalText = "Approval No. - 890 / Dyde - Pune - 16798 - 27/07/2016. ISO 9001:2015";
    const contactText = "Phone No.7796686110, Email- sems@vidyapratishthan.com";
    const udiseNum = "27250200605";
    const indexNum = "1102078";
    const mediumText = "English";
    const boardText = "SSC";

    return (
        <Box sx={{
            border: '2px solid #000',
            p: 1.5,
            mb: 2,
            width: '100%',
            boxSizing: 'border-box',
            fontFamily: '"Times New Roman", Georgia, serif',
            color: '#000',
            backgroundColor: '#fff'
        }}>
            {/* Top row with Logo and school title */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 1 }}>
                <Box
                    component="img"
                    src="/logo1.png"
                    alt="School Logo"
                    sx={{ width: 65, height: 65, objectFit: 'contain' }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                />
                <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 'bold', lineHeight: 1.2 }}>
                        VIDYA PRATISHTHAN'S
                    </Typography>
                    <Typography sx={{ fontSize: 18, fontWeight: 'bold', lineHeight: 1.2, mt: 0.5 }}>
                        SUPE ENGLISH MEDIUM SCHOOL
                    </Typography>
                    <Typography sx={{ fontSize: 9, mt: 0.5 }}>
                        {schoolAddress}
                    </Typography>
                    <Typography sx={{ fontSize: 9 }}>
                        Approval No. - 890 / Dyde - Pune - 16798 - 27/07/2016.
                        <br />
                        ISO 9001:2015
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                        <Typography sx={{ fontSize: 9 }}>
                            {contactText}
                        </Typography>
                    </Box>
                </Box>
                
                {/* Index No box on the right of the header */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', minWidth: 80 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, border: '1px solid #000', px: 0.8, py: 0.3 }}>
                        <Typography sx={{ fontSize: 9, fontWeight: 'bold' }}>
                            Index No:-
                        </Typography>
                        <Typography sx={{ fontSize: 9, fontWeight: 'bold' }}>
                            {indexNum}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Divider line inside header */}
            <Box sx={{ borderTop: '1px solid #000', my: 0.5 }} />

            {/* Bottom row: U-DISE Number, Medium, Board */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1 }}>
                <Typography sx={{ fontSize: 10 }}>
                    School U-DISE Number – <strong>{udiseNum}</strong>
                </Typography>
                <Typography sx={{ fontSize: 10 }}>
                    Medium : <strong>{mediumText}</strong>, Board : <strong>{boardText}</strong>
                </Typography>
            </Box>
        </Box>
    );
};

export default CertificateHeader;
